
// .................................................................................

document.addEventListener("DOMContentLoaded", function () {
  const marquee = document.querySelector(".marquee");
  const wrapper = document.querySelector(".feature-wrapper");
  let content = marquee.innerHTML;
  while (wrapper.scrollWidth < window.innerWidth * 2) {
    marquee.innerHTML += content;
  }
});

// .................................................................................

var swiper = new Swiper(".social-proof-marquee-rtl", {
  spaceBetween: 30,
  centeredSlides: true,
  speed: 5500,
  autoplay: {
    delay: 0,
    reverseDirection: true
  },
  loop: true,
  slidesPerView: "auto",
  allowTouchMove: false,
  disableOnInteraction: true,
  breakpoints: {
    0: {
      slidesPerView: 2
    },
    550: {
      slidesPerView: "auto",
    }
  }
});
var swiper = new Swiper(".social-proof-marquee-ltr", {
  spaceBetween: 30,
  centeredSlides: true,
  speed: 5500,
  autoplay: {
    // disableOnInteraction: false,
    // pauseOnMouseEnter: true,
    delay: 0
  },
  loop: true,
  slidesPerView: "auto",
  allowTouchMove: false,
  disableOnInteraction: true,
  breakpoints: {
    0: {
      slidesPerView: 2
    },
    550: {
      slidesPerView: "auto",
    }
  }
});

// .................................................................................

var swiper = new Swiper(".image-testi-swiper", {
  spaceBetween: 30,
  loop: false,
  slidesPerView: 3,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    0: {
      slidesPerView: 1
    },
    550: {
      slidesPerView: 3,
    }
  }
});

// .................................................................................

var swiper = new Swiper(".comfort-performance-swiper", {
  spaceBetween: 100,
  loop: false,
  slidesPerView: 2,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    0: {
      slidesPerView: 1
    },
    550: {
      slidesPerView: 2,
    }
  }
});

// .................................................................................

var swiper = new Swiper(".workout-boxes-swiper", {
  spaceBetween: 100,
  loop: false,
  slidesPerView: 3,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    0: {
      slidesPerView: 1
    },
    550: {
      slidesPerView: 3,
    }
  }
});

// .................................................................................

$(".single-faq--box").click(function(){
  $(this).children(".faq-accordion-content").slideToggle();
  $(this).find(".faq-plus-svg").toggle();
  $(this).find(".faq-minus-svg").toggle();
});

// .................................................................................

var swiper = new Swiper(".cart-review-swiper", {
  spaceBetween: 30,
  loop: true,
  slidesPerView: 1.3,
  grabCursor: true,
});

// .................................................................................

var swiper = new Swiper(".video--swiper", {
  spaceBetween: 30,
  loop: true,
  slidesPerView: 4,
  grabCursor: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    0: {
      slidesPerView: 1.5,
      centeredSlides: true,
      loop: true
    },
    550: {
      slidesPerView: 4,
    }
  }
});

// .................................................................................

// document.querySelector('.add--btn').addEventListener('click', function (e) {
//   e.preventDefault();
//   const form = document.querySelector('product-form form[data-type="add-to-cart-form"]');
//   if (!form) {
//     console.error('Product form not found');
//     return;
//   }
//   form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
// });

// .................................................................................

document.querySelector('.add--btn').addEventListener('click', function(event) {
  event.preventDefault(); // Prevent the default action of the <a> tag (navigation)

  const form = document.querySelector('product-form form[data-type="add-to-cart-form"]');
  if (form) {
    form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
  } else {
    alert('Form not found!');
  }
});
document.querySelector('.add--btn-second').addEventListener('click', function(event) {
  event.preventDefault(); // Prevent the default action of the <a> tag (navigation)

  const form = document.querySelector('product-form form[data-type="add-to-cart-form"]');
  if (form) {
    form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
  } else {
    alert('Form not found!');
  }
});


// .................................................................................



// .................................................................................



// .................................................................................



// .................................................................................



// .................................................................................



// .................................................................................



// .................................................................................



// .................................................................................



// .................................................................................



// .................................................................................
